export default {
  appointmentContainer: {
    title: 'Property Damage',
    solution: 'Solution:',
    text: 'Choose an Allianz-approved professional',
    text2: 'Desired date for the work',
    text3: 'Desired passage time:',
    infoBox: 'If the slots are unavailable or incompatible with your availability, choose to be called back to schedule the appointment within 48h*.',
    workHour: '*Business hours and except for exceptional or uncontrollable issues',
    actions: {
      primary: 'Confirm time',
      secondaryHelpText: 'None of these slots are convenient for you?',
      secondary: 'Be called back to schedule an appointment',
      ren: {
        primary: 'Validate the time slot',
        tertiary: 'Choose another solution'
      },
      wld: {
        primary: 'Confirm appointment',
        secondary: 'I do not want an appointment'
      }
    },
    wld: {
      title: 'Choose an appointment slot',
      text: 'Select a date and time for the technician visit.',
      infoText: 'If the slots are unavailable or incompatible with your availability, choose to be called back to schedule the appointment.'
    },
    dates: {
      months: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December'
      }
    },
    notifications: {
      errors: {
        getSchedule: 'Error! It was not possible to retrieve the days available for appointment.',
        postAppointment: 'Error! The selected appointment could not be scheduled.',
        postContact: 'Error! The contact could not be requested.'
      }
    }
  }
}
